import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { RequestDownloadExcelDto, RequestReportSendEmailExcelDto, RequestReportSendEmailPdfDto } from "../../shared/nestjs/gd-only/dto/emp-ovt-report.dto";
import { OvertimeReportApi } from "../../shared/nestjs/gd-only/services/overtime-report.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk";
import { ViewOvertimeReportApi } from "../../shared/sdk/services/custom";
@Injectable()
export class OvertimeReportBloc {
  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private viewOvertimeReportApi: ViewOvertimeReportApi,
    private nestApiProvider: NestApiProvider,
    private fileDownloaderProvider: FileDownloaderProvider,
    private platform: Platform,
    private overtimeReportApi: OvertimeReportApi,
    private analyticsProvider: AnalyticsProvider
  ) {

  }

  generatePreview(obj_data): Observable<any> {
    return this.viewOvertimeReportApi.previewReport(obj_data);
  }


  downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
    return this.overtimeReportApi.downloadExcel(data)
  }

  downloadExcelLB(data): Promise<any> {
    return new Promise(async (resolve, reject) => {

    })
  }

  generateExcel(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, 'Overtime Report')
    } else {
      saveAs(data, 'Overtime Request Report.xlsx')
    }
  }

  downloadPdf(data): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return this.overtimeReportApi.downloadPdf(data)
  }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Overtime Report')
    } else {
      saveAs(data, 'Overtime Request Report.pdf')
    }
  }

  generatePdfLB(data): Promise<any> {
    return new Promise(async (resolve, reject) => {

    })
  }

  sendExcel(data):Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          let dataNest : RequestReportSendEmailExcelDto = new RequestReportSendEmailExcelDto();
          dataNest.allEmp = data.allEmp;
          dataNest.listEmp = data.listEmp;
          dataNest.email = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate
          return this.overtimeReportApi.reportSendEmailExcel(dataNest)
        }else{
          data.sendEmail = true;
          return this.viewOvertimeReportApi.download(data)
        }
      })
  }

  sendPdf(data):Observable<any>{
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          let dataNest : RequestReportSendEmailPdfDto = new RequestReportSendEmailPdfDto();
          dataNest.allEmp = data.allEmp;
          dataNest.listEmp = data.listEmp;
          dataNest.email = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate;
          return this.overtimeReportApi.reportSendEmailPdf(dataNest)
        }else {
          data.sendEmail = true;
         return this.viewOvertimeReportApi.pdfmake(data)
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/overtime-report.bloc.ts